import React, { useEffect, useState } from 'react';
import api from '@/lib/api';
import { PageHeader } from '@/components/app/PageHeader';
import { Card } from '@/components/ui/card';
import { formatINR, fmtDate } from '@/lib/format';
import { StatusPill } from '@/components/app/StatusPill';

export default function MaintenanceReview() {
  const [data, setData] = useState({ tickets: [], by_status: {}, by_priority: {}, total_cost: 0, total: 0 });
  useEffect(() => { api.get('/reports/maintenance-summary').then(r => setData(r.data)); }, []);
  return (
    <div>
      <PageHeader title="Maintenance review" subtitle="Open and historical tickets across portfolio" />
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
        <Card className="p-4"><div className="text-xs text-muted-foreground">Total tickets</div><div className="text-2xl font-display font-semibold">{data.total}</div></Card>
        <Card className="p-4"><div className="text-xs text-muted-foreground">In progress</div><div className="text-2xl font-display font-semibold">{data.by_status?.in_progress || 0}</div></Card>
        <Card className="p-4"><div className="text-xs text-muted-foreground">Closed</div><div className="text-2xl font-display font-semibold">{(data.by_status?.completed || 0) + (data.by_status?.closed || 0)}</div></Card>
        <Card className="p-4"><div className="text-xs text-muted-foreground">Total cost</div><div className="text-2xl font-display font-semibold">{formatINR(data.total_cost)}</div></Card>
      </div>
      <Card className="p-0 overflow-x-auto">
        <table className="w-full min-w-[640px] text-sm">
          <thead className="bg-muted/60">
            <tr>
              <th className="text-left px-3 py-2 text-xs uppercase text-muted-foreground">Ticket</th>
              <th className="text-left px-3 py-2 text-xs uppercase text-muted-foreground">Title</th>
              <th className="text-left px-3 py-2 text-xs uppercase text-muted-foreground">Property / Unit</th>
              <th className="text-left px-3 py-2 text-xs uppercase text-muted-foreground">Priority</th>
              <th className="text-left px-3 py-2 text-xs uppercase text-muted-foreground">Status</th>
              <th className="text-right px-3 py-2 text-xs uppercase text-muted-foreground">Cost</th>
              <th className="text-left px-3 py-2 text-xs uppercase text-muted-foreground">Created</th>
            </tr>
          </thead>
          <tbody>
            {(data.tickets || []).map((t) => (
              <tr key={t.id} className="border-t hover:bg-muted/40">
                <td className="px-3 py-2 font-mono">{t.ticket_number}</td>
                <td className="px-3 py-2">{t.title}</td>
                <td className="px-3 py-2">{t.property_name} / {t.unit_number}</td>
                <td className="px-3 py-2 uppercase font-mono text-xs">{t.priority}</td>
                <td className="px-3 py-2"><StatusPill status={t.status} /></td>
                <td className="px-3 py-2 text-right tabular-nums">{formatINR(t.actual_cost || t.estimated_cost)}</td>
                <td className="px-3 py-2">{fmtDate(t.created_at)}</td>
              </tr>
            ))}
            {!(data.tickets || []).length && <tr><td colSpan={7} className="text-center text-muted-foreground py-8">No tickets found.</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
